import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import { isBrowser } from 'react-device-detect';
import OrderBox from './OrderBox';
import { Box, Typography } from '@mui/material';

const DrawerOrderBox = (props: { openOrderBox: any; setOpenOrderBox: any; checkLimitText: any; selectRequired: any; setSelectRequired: any; }) => {
const { openOrderBox, setOpenOrderBox, checkLimitText, selectRequired, setSelectRequired } = props;

const closeOrderBox =()=> { 
	// if (!isBrowser) {
	// 	if (window.ReactNativeWebView !== undefined) {
	// 		window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
	// 	} else if(window.Android !== undefined){
	// 		window.Android.postMessage(JSON.stringify({'type':'play'}));
	// 	}
	// };
	setOpenOrderBox(false);
}

  return (
    <div>
			<React.Fragment key={'right'}>
					<Drawer
						transitionDuration={100}
						anchor={'right'}
						open={openOrderBox}
						onClose={closeOrderBox}
					>
						<Box sx={{display: 'flex', flexDirection: 'row',  padding: '2.0rem 1.9rem', justifyContent: 'flex-start', alignItems: 'center'}}>
							<Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
								<Typography sx={{ml: '1.0rem', fontSize: '2.8rem', fontWeight: '700', fontStyle: 'normal', lineHeight: 'normal', color: '#000', letterSpacing: '.056rem', height: '4.2rem'}}>Draft Order</Typography>
								<div className="touch-area" style={{position: 'absolute',right: '3.1rem',top: '2.9rem',}} onClick={() => {
										// if (!isBrowser) {
										// 	if (window.ReactNativeWebView !== undefined) {
										// 		window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
										// 	} else if(window.Android !== undefined){
										// 		window.Android.postMessage(JSON.stringify({'type':'play'}));
										// 	}
										// }
										setOpenOrderBox(false)
									}}>
								<img style={{width: '2.5rem', height: '2.5rem'}}
									src={process.env.PUBLIC_URL+'/assets/images/close.svg'}
									alt="close"
								/>
								</div>
							</Box>
						</Box>
						<OrderBox setOpenOrderBox={setOpenOrderBox} checkLimitText={checkLimitText} selectRequired={selectRequired} setSelectRequired={setSelectRequired}/>
					</Drawer>
			</React.Fragment>
    </div>
  );
}

export default DrawerOrderBox;
